import {createRoot} from "react-dom/client";
import {Navigate, Route, Routes} from "react-router-dom";
import SettingsPage from "./eventer-console/app/pages/accounts/settings/SettingsPage.tsx";
import ImportersPage from "./eventer-console/app/pages/accounts/importers/ImportersPage.tsx";
import AccountsGuard from "./eventer-console/app/pages/accounts/AccountsGuard.tsx";
import AuthenticationGuard from "./appfw/authentication/AuthenticationGuard.tsx";
import NewAccountPage from "./eventer-console/app/pages/accounts/new/NewAccountPage.tsx";
import SplashScreenOutlet from "./eventer-console/app/splash/SplashScreenOutlet.tsx";
import AccountGuard from "./eventer-console/app/pages/accounts/AccountGuard.tsx";
import EventsFeed from "./eventer-console/app/pages/accounts/events/EventsFeed.tsx";
import {AppFwContext} from "./appfw/AppFwContext.ts";
import AppFwWrapper from "./appfw/AppFwWrapper.tsx";
import AppFwOverlay from "./appfw/ui/layouts/AppFwOverlay.tsx";
import AppFwLayout from "./appfw/ui/layouts/AppFwLayout.tsx";
import {EventerConsoleNavigation} from "./eventer-console/EventerConsoleNavigation.tsx";
import MembersPage from "./eventer-console/app/pages/accounts/members/MembersPage.tsx";
import InvitationPage from "./eventer-console/app/pages/accounts/invitations/InvitationPage.tsx";
import {AccountsProvider} from "./eventer-console/app/pages/accounts/Accounts.tsx";
import EventerConsoleApp from "./eventer-console/app/EventerConsoleApp.tsx";
import SendEmailsPage from "./eventer-console/app/pages/accounts/services/emails/SendEmailsPage.tsx";
import "./eventer-console/help/help-init.ts";
import HelpGCalPage from "./eventer-console/app/pages/accounts/help/HelpGCalPage.tsx";


if ('serviceWorker' in navigator) {

    window.addEventListener('load', async () => {
        // de-register all unknown service-workers
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
            const scriptURL = registration.active?.scriptURL || '';
            console.log("[SW] Check service worker:", scriptURL);
            if (!scriptURL.includes('/sw.js')) {
                console.log('[SW] found old service worker:', scriptURL, ' ➔ unregister...');
                await registration.unregister();
            }
        }

        // 2. Neuer Service Worker aktiviert → Seite hart neu laden
        // navigator.serviceWorker.addEventListener('controllerchange', () => {
        //     // TODO: update dialog? ==> needs also change on service worker side
        //     console.log('[SW] Neuer Service Worker aktiv – Seite wird neu geladen.');
        //     window.location.reload();
        // });
    });
}


let AppRoutes =
    <Routes>

        {/* redirect `/` to `/accounts` (which redirects to `/accounts/:accountId` or `/accounts/new`) */}
        <Route index element={<Navigate to={EventerConsoleNavigation.accounts.path} replace/>}/>

        {/* special route: invitation (user must not be member of the account) */}
        <Route path={EventerConsoleNavigation.accounts.accountTemplate().invitations.invitationTemplate().path}
               element={
                   <AccountsProvider>
                       <AppFwOverlay title={"Account beitreten"} forceClose>
                           <InvitationPage/>
                       </AppFwOverlay>
                   </AccountsProvider>
               }/>

        <Route path={EventerConsoleNavigation.accounts.path}
               element={<AccountsGuard newAccountPath={EventerConsoleNavigation.accounts.new.path}/>}>

            <Route element={<EventerConsoleApp/>}>

                {/* overlay routes */}
                <Route path={EventerConsoleNavigation.accounts.new.path} element={
                    <AppFwOverlay title={"Neuen Pod erstellen"} forceClose>
                        <NewAccountPage/>
                    </AppFwOverlay>
                }/>

                {/* layout routes */}
                <Route element={<AppFwLayout/>}>
                    <Route path={EventerConsoleNavigation.accounts.accountTemplate().segment} element={<AccountGuard/>}>

                        {/* redirect `/accounts/:id` to ==> `events` */}
                        <Route index
                               element={
                                   <Navigate to={EventerConsoleNavigation.accounts.accountTemplate().events.segment}
                                             replace/>
                               }
                        />

                        <Route path={EventerConsoleNavigation.accounts.accountTemplate().events.segment}
                               element={<EventsFeed/>}/>
                        <Route path={EventerConsoleNavigation.accounts.accountTemplate().importers.segment}
                               element={<ImportersPage/>}/>

                        <Route path={EventerConsoleNavigation.accounts.accountTemplate().services.segment}>

                            {/* redirect `/accounts/:id/services` to ==> `/accounts/:id/services/emails` */}
                            <Route index
                                   element={
                                       <Navigate
                                           to={EventerConsoleNavigation.accounts.accountTemplate().services.emails.segment}
                                           replace/>
                                   }
                            />

                            <Route
                                path={EventerConsoleNavigation.accounts.accountTemplate().services.emails.segment}
                                element=<SendEmailsPage/>
                            />
                        </Route>

                        <Route path={EventerConsoleNavigation.accounts.accountTemplate().help.segment}>

                            {/* redirect `/accounts/:id/help` to ==> `/accounts/:id/help/gcal` */}
                            <Route index
                                   element={
                                       <Navigate
                                           to={EventerConsoleNavigation.accounts.accountTemplate().help.gcal.segment}
                                           replace/>
                                   }
                            />

                            <Route
                                path={EventerConsoleNavigation.accounts.accountTemplate().help.gcal.segment}
                                element={<HelpGCalPage/>}
                            />
                        </Route>

                        <Route path={EventerConsoleNavigation.accounts.accountTemplate().settings.segment}>

                            {/* redirect `/accounts/:id/settings` to ==> `/accounts/:id/settings/users` */}
                            <Route index
                                   element={
                                       <Navigate
                                           to={EventerConsoleNavigation.accounts.accountTemplate().settings.users.segment}
                                           replace/>
                                   }
                            />

                            <Route
                                path={EventerConsoleNavigation.accounts.accountTemplate().settings.users.segment}
                                element={<MembersPage/>}
                            />
                            <Route
                                path={EventerConsoleNavigation.accounts.accountTemplate().settings.pod.segment}
                                element={<SettingsPage/>}
                            />
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Route>

        {/* Global not found route => general 404 page + specific 404 pages */}
        <Route path="*" element={<Navigate to={EventerConsoleNavigation.accounts.path} replace/>}/>
    </Routes>


const appFwContext = new AppFwContext({
    appName: "eventer-console",
    authentication: {
        oidcProviders: ["google", "apple"],
    }
})


const node = document.getElementById('root') as HTMLElement
createRoot(node).render(
    <AppFwWrapper appFwContext={appFwContext}>
        <AuthenticationGuard splashScreenOutlet={<SplashScreenOutlet/>}>
            {AppRoutes}
        </AuthenticationGuard>
    </AppFwWrapper>
)